module.exports = __webpack_public_path__ + "static/media/braces.3478b406.svg";